// The meeting's own lists (owner decision 2026-10-16, 3a): what
// it decided ("Beschlüsse"), what someone said they would do that is no
// work item ("Zusagen": a reply owed, how the team works) and the questions
// it left open ("Offen geblieben"). On the owner's page only: never written
// to the project, never on the magic link. Each line is the server's cut of
// the transcript line, with its speaker label, its time (minutes into the
// meeting; none for a line no speaker was matched to, whose time is only its
// chunk's start) and the subject it was about. A meeting from before the line tags, or past its 30 days, has
// no lists: the page shows its "Beschlüsse" rows instead.

import { meetingClock, type MeetingListsDto, type MeetingNoteDto } from "@loom/shared/meetings";

import { useT, type MessageKey } from "../../i18n/index.js";

function NoteList({ title, notes }: { readonly title: MessageKey; readonly notes: readonly MeetingNoteDto[] }) {
  const t = useT();
  if (notes.length === 0) return null;
  return (
    <section className="meet-section" aria-label={t(title)}>
      <h2 className="meet-section-title">{t(title)}</h2>
      <ul className="meet-list">
        {notes.map((n) => (
          <li key={n.key} className="meet-row" data-note={n.key}>
            <q className="meet-quote">{n.text}</q>
            <span className="meet-meta">
              {n.speakerLabel ?? t("meetings.quote.unknownSpeaker")}
              {n.speakerLabel !== null && (
                <>
                  {" · "}
                  {t("meetings.quote.at", { clock: meetingClock(n.approxMs) })}
                </>
              )}
              {n.about !== null && (
                <>
                  {" · "}
                  {t("meetings.lists.about", { about: n.about })}
                </>
              )}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export function MeetingLists({ lists }: { readonly lists: MeetingListsDto }) {
  return (
    <>
      <NoteList title="meetings.decisions.title" notes={lists.decisions} />
      <NoteList title="meetings.lists.commitments" notes={lists.commitments} />
      <NoteList title="meetings.lists.questions" notes={lists.questions} />
    </>
  );
}
